import { render, staticRenderFns } from "./terDioShow.vue?vue&type=template&id=4025fee4&scoped=true"
import script from "./terDioShow.vue?vue&type=script&lang=js"
export * from "./terDioShow.vue?vue&type=script&lang=js"
import style0 from "./terDioShow.vue?vue&type=style&index=0&id=4025fee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025fee4",
  null
  
)

export default component.exports